import { Views } from "react-big-calendar";
import { Button } from "@/components/ui/button";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { ChevronLeft, ChevronRight, Plus } from "lucide-react";

// Schedule -> top toolbar (date nav, resource select, view tabs, new
// lesson button). Extracted from Schedule.js (props-driven, no behavior
// change).
export const ScheduleToolbar = ({
  dateLabel,
  onPrev,
  onNext,
  onToday,
  isStaff,
  resourceMode,
  selectedInstructor,
  instructors,
  onResourceChange,
  view,
  onViewChange,
  onNewLesson,
}) => (
  <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3">
    <div className="flex items-center gap-2">
      <Button variant="outline" size="icon" className="h-10 w-10" onClick={onPrev} data-testid="schedule-prev-button">
        <ChevronLeft className="h-4 w-4" />
      </Button>
      <Button variant="outline" size="sm" className="h-10" onClick={onToday} data-testid="schedule-today-button">
        Today
      </Button>
      <Button variant="outline" size="icon" className="h-10 w-10" onClick={onNext} data-testid="schedule-next-button">
        <ChevronRight className="h-4 w-4" />
      </Button>
      <p className="font-medium text-sm ml-1 hidden sm:block">{dateLabel}</p>
    </div>

    <div className="flex flex-wrap items-center gap-2">
      {isStaff && (
        <select
          className="h-10 rounded-[var(--radius)] border bg-background px-3 text-sm"
          value={resourceMode === "all" ? "all" : selectedInstructor}
          onChange={(e) => onResourceChange(e.target.value)}
          data-testid="scheduler-resource-select"
        >
          <option value="all">Entire School</option>
          {instructors.map((i) => (
            <option key={i.id} value={i.id}>{i.full_name}</option>
          ))}
        </select>
      )}
      <Tabs value={view} onValueChange={onViewChange} data-testid="scheduler-view-tabs">
        <TabsList>
          <TabsTrigger value={Views.DAY} data-testid="scheduler-view-day">Day</TabsTrigger>
          <TabsTrigger value={Views.WEEK} data-testid="scheduler-view-week">Week</TabsTrigger>
          <TabsTrigger value={Views.MONTH} data-testid="scheduler-view-month">Month</TabsTrigger>
          <TabsTrigger value={Views.AGENDA} data-testid="scheduler-view-agenda">List</TabsTrigger>
        </TabsList>
      </Tabs>
      {isStaff && (
        <Button className="h-10 bg-[hsl(var(--role-accent))] hover:opacity-95" onClick={onNewLesson} data-testid="schedule-new-lesson-button">
          <Plus className="h-4 w-4 mr-2" /> New
        </Button>
      )}
    </div>
  </div>
);
